/// Blok:richTextAnchor
// anchor:blok
///
/// anchor_name:string
function RichTextAnchor({ blok }) {
  let name = blok.anchor_name;
  if (!blok.anchor_name) {
    return null;
  } else {
    //only allow letters, numbers, underscore, period, and hyphen
    name = blok.anchor_name.replaceAll(/([^a-zA-Z0-9_])/g, "");
  }

  return <a id={name} name={name} />;
}

export default RichTextAnchor;
